import React from "react";

const ReportCalendar = ({ selected }) => {
  const activeColor = "rgba(38, 127, 215, 1)";
  const inactiveColor = "#707070";

  if (selected) {
    return (
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          opacity="0.12"
          d="M2.5 7.33333C2.5 5.9332 2.5 5.23313 2.77248 4.69835C3.01217 4.22795 3.39462 3.8455 3.86502 3.60581C4.3998 3.33333 5.09987 3.33333 6.5 3.33333H13.5C14.9001 3.33333 15.6002 3.33333 16.135 3.60581C16.6054 3.8455 16.9878 4.22795 17.2275 4.69835C17.5 5.23313 17.5 5.9332 17.5 7.33333V8.33333H2.5V7.33333Z"
          fill={activeColor}
        />
        <path
          d="M17.5 8.33334H2.5M13.3333 1.66667V5.00001M6.66667 1.66667V5.00001M6.5 18.3333H13.5C14.9001 18.3333 15.6002 18.3333 16.135 18.0609C16.6054 17.8212 16.9878 17.4387 17.2275 16.9683C17.5 16.4335 17.5 15.7335 17.5 14.3333V7.33334C17.5 5.93321 17.5 5.23314 17.2275 4.69836C16.9878 4.22796 16.6054 3.84551 16.135 3.60582C15.6002 3.33334 14.9001 3.33334 13.5 3.33334H6.5C5.09987 3.33334 4.3998 3.33334 3.86502 3.60582C3.39462 3.84551 3.01217 4.22796 2.77248 4.69836C2.5 5.23314 2.5 5.93321 2.5 7.33334V14.3333C2.5 15.7335 2.5 16.4335 2.77248 16.9683C3.01217 17.4387 3.39462 17.8212 3.86502 18.0609C4.3998 18.3333 5.09987 18.3333 6.5 18.3333Z"
          stroke={activeColor}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  }

  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.12"
        d="M2.5 7.33333C2.5 5.9332 2.5 5.23313 2.77248 4.69835C3.01217 4.22795 3.39462 3.8455 3.86502 3.60581C4.3998 3.33333 5.09987 3.33333 6.5 3.33333H13.5C14.9001 3.33333 15.6002 3.33333 16.135 3.60581C16.6054 3.8455 16.9878 4.22795 17.2275 4.69835C17.5 5.23313 17.5 5.9332 17.5 7.33333V8.33333H2.5V7.33333Z"
        fill={inactiveColor}
      />
      <path
        d="M17.5 8.33334H2.5M13.3333 1.66667V5.00001M6.66667 1.66667V5.00001M6.5 18.3333H13.5C14.9001 18.3333 15.6002 18.3333 16.135 18.0609C16.6054 17.8212 16.9878 17.4387 17.2275 16.9683C17.5 16.4335 17.5 15.7335 17.5 14.3333V7.33334C17.5 5.93321 17.5 5.23314 17.2275 4.69836C16.9878 4.22796 16.6054 3.84551 16.135 3.60582C15.6002 3.33334 14.9001 3.33334 13.5 3.33334H6.5C5.09987 3.33334 4.3998 3.33334 3.86502 3.60582C3.39462 3.84551 3.01217 4.22796 2.77248 4.69836C2.5 5.23314 2.5 5.93321 2.5 7.33334V14.3333C2.5 15.7335 2.5 16.4335 2.77248 16.9683C3.01217 17.4387 3.39462 17.8212 3.86502 18.0609C4.3998 18.3333 5.09987 18.3333 6.5 18.3333Z"
        stroke={inactiveColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default ReportCalendar;
